export { getUAResult } from './uaParser';



// WEBPACK FOOTER //
// ../../../../src/metas/shared/index.ts